import { DataTestIdEnum } from '@medprev-web-app/datatestid';

export function scrollSearchResultsToTop(): void {
  const resultsContainer = document.querySelector(
    `[data-testid="${DataTestIdEnum.PROCEDURES_MODAL_SEARCH_RESULTS_CONTAINER}"]`,
  ) as HTMLElement | null;

  resultsContainer?.scrollTo({ top: 0, behavior: 'smooth' });
}
